<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div class="text item">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="商品名称：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入商品名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
            <el-button type="primary" style="margin-left: 40px;" @click="addGoodsBtn">添加商品</el-button>
          </el-form-item>
        </el-form>
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="relatedGoodsName"
            label="商品名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="thumb"
            label="商品图">
            <template slot-scope="scope">
              <el-image
                class="mt-table-goods-img"
                :src="scope.row.thumb == null ? imgServer+'no_img.png' : scope.row.thumb"
                :preview-src-list="[scope.row.thumb]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="apiSpecPrice"
            label="商品售价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="delBtn(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { queryGoodsRelatedPageList, removeGoodsRelatedById  } from '@/api/goods'
export default {
  name: 'RecommendGoodsList',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 跳转添加商品页面
    addGoodsBtn(){
      var dataId = this.dataId;
      this.$router.push({path: '/goods_recommend_goods_add', query: {dataId: dataId}})
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryGoodsRelatedPageList({ relatedGoodsName: searchName, goodsId: that.dataId, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeGoodsRelatedById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/RecommendGoodsList.vue